module.exports = __webpack_public_path__ + "media/assets/images/smart_working/5-1-b3e1c0311482dcd170d7f949c5df5435.png";